import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import clsx from "clsx";
import QRCode from "qrcode.react";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, withRouter } from "react-router-dom";
import { IP } from "../../../config/IP";
import { loadOrder, updateOrder } from "../../services/order/actions";
import AddressForm from "./AddressForm";
import Error from "./Error";
import "./index.css";
import PaymentForm from "./PaymentForm";
import Review from "./Review";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		minWidth: "75ch",
	},
	button: {
		marginRight: theme.spacing(1),
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		width: "100%",
	},
	list: {
		width: 250,
	},
	fullList: {
		width: "100%",
	},
}));

function getSteps() {
	return ["Identication", "Payment Info", "Confirmation"];
}

function getStepContent(step, ref, data) {
	switch (step) {
		case 0:
			return <AddressForm ref={ref} data={data} />;
		case 1:
			return <PaymentForm ref={ref} />;
		case 2:
			return <Review />;
		default:
			return "Unknown step";
	}
}
const OrderScreen = (props) => {
	const dispatch = useDispatch();
	const state = useSelector((state) => state);
	const { orderId } = useParams();
	const classes = useStyles();
	const [stateCart, setStateCart] = React.useState({
		top: false,
		left: false,
		bottom: false,
		right: false,
	});
	const [firstLoad, setFirstLoad] = React.useState(true);
	const [activeStep, setActiveStep] = React.useState(0);

	const [skipped, setSkipped] = React.useState(new Set());
	const steps = getSteps();
	const ref = useRef();

	const isStepOptional = (step) => {
		return step === 0;
	};

	const isStepSkipped = (step) => {
		return skipped.has(step);
	};

	const handleNext = () => {
		if (activeStep === 0) {
			console.log(
				"addressRef.current.addressInputs=",
				ref.current.addressInputs
			);
			if (!ref.current.addreesSaveCond) {
				return;
			} else {
				let inputs = {
					url: IP.nodeServer + "api/createOrder",
					method: "POST",
					data: {
						...ref.current.addressInputs,
						orderId: orderId,
						isAuthenticated: false,
					},
				};
				console.log("updateOrder inputs=", inputs);
				dispatch(updateOrder(inputs));
			}
		}
		if (activeStep === 1) {
			if (!ref.current.paymentCond) {
				return;
			} else {
				let inputs = {
					url: IP.nodeServer + "api/createOrder",
					method: "POST",
					data: {
						...ref.current.paymentInputs,
						orderId: orderId,
						isAuthenticated: false,
					},
				};
				console.log("updateOrder inputs=", inputs);
				dispatch(updateOrder(inputs));
			}
		}
		if (activeStep === 2) {
			console.log("Finish hit");

			let inputs = {
				url: IP.nodeServer + "api/createOrder",
				method: "POST",
				data: {
					action: "confirm_finish",
					orderId: orderId,
					isAuthenticated: false,
				},
			};
			console.log("updateOrder inputs=", inputs);
			dispatch(updateOrder(inputs));
		}
		let newSkipped = skipped;
		if (isStepSkipped(activeStep)) {
			newSkipped = new Set(newSkipped.values());
			newSkipped.delete(activeStep);
		}

		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setSkipped(newSkipped);
		setFirstLoad(false);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleSkip = () => {
		if (!isStepOptional(activeStep)) {
			// You probably want to guard against something like this,
			// it should never occur unless someone's actively trying to break something.
			throw new Error("You can't skip a step that isn't optional.");
		}

		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setSkipped((prevSkipped) => {
			const newSkipped = new Set(prevSkipped.values());
			newSkipped.add(activeStep);
			return newSkipped;
		});
	};

	const handleReset = () => {
		setActiveStep(0);
		setFirstLoad(false);
	};
	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setStateCart({ ...stateCart, [anchor]: open });
	};

	const list = (anchor) => (
		<div
			className={clsx(classes.list, {
				[classes.fullList]: anchor === "top" || anchor === "bottom",
			})}
			role="presentation"
			onClick={toggleDrawer(anchor, false)}
			onKeyDown={toggleDrawer(anchor, false)}
		>
			<React.Fragment>
				<div align="left" className="close">
					&times;
				</div>
				<Divider />

				<span
					className="fa-stack fa-1x has-badge"
					data-count={state.order.order.items.reduce(
						(x, y) => x + y.quantity,
						0
					)}
					onClick={toggleDrawer(anchor, true)}
				>
					<i className="fa fa-circle fa-stack-1x fa-inverse"></i>
					<i className="fa fa-shopping-bag fa-stack-1x red-cart"></i>
				</span>

				<Typography variant="h6" gutterBottom>
					Order summary
				</Typography>
				<Divider />
				<List disablePadding>
					{state.order.order.items.map((product) => (
						<ListItem className={classes.listItem} key={product.sku}>
							<ListItemText primary={product.title} secondary={product.style} />
							<ListItemText primary="Quantity" secondary={product.quantity} />
							<Typography variant="body2">
								{product.currencyId +
									"" +
									Intl.NumberFormat().format(product.price)}
							</Typography>
						</ListItem>
					))}
					<ListItem className={classes.listItem}>
						<ListItemText primary="Total" />
						<Typography variant="subtitle1" className={classes.total}>
							{state.order.order.currencyId +
								"" +
								Intl.NumberFormat().format(state.order.order.totalCost)}
						</Typography>
					</ListItem>
				</List>
			</React.Fragment>
			<Divider />
		</div>
	);

	console.log("props.location.state=", props.location.state);
	useEffect(() => {
		console.log("Order Screen orderId=", orderId);
		let inputs = {
			url: IP.nodeServer + "api/loadOrder",
			method: "POST",
			data: { orderId: orderId },
		};
		console.log("loadOrder inputs=", inputs);
		dispatch(loadOrder(inputs));
	}, []);
	useEffect(() => {
		if (state.order.isFailed) {
			console.log("Order Screen orderId=", orderId);
			let inputs = {
				url: IP.nodeServer + "api/loadOrder",
				method: "POST",
				data: { orderId: orderId },
			};
			console.log("loadOrder inputs=", inputs);
			dispatch(loadOrder(inputs));
		}
	}, [state.order.isFailed]);
	useEffect(() => {
		console.log("activeStep=", activeStep);
		console.log("state.order.order.step=", state.order.order.step);
		console.log("firstLoad=", firstLoad);

		if (
			((state.order.isLoaded ||
				state.order.isUpdated ||
				state.order.isFailed) &&
				activeStep + 1 > state.order.order.step &&
				state.order.order.step !== 1) ||
			(activeStep === 0 && state.order.isLoaded && state.order.order.step !== 1)
		) {
			console.log("has entered condition activeStep=", activeStep);
			setActiveStep(state.order.order.step ? state.order.order.step - 1 : 0);
			console.log(
				`IP.reactServer/ Shop/ Order /state.order.order._id=`,
				IP.reactServer + "Shop/Order/" + state.order.order._id
			);
		}
	}, [
		state.order.isLoaded,
		state.order.isUpdated,
		state.order.isFailed,
		activeStep,
	]);
	if (
		(!state.order.isLoaded &&
			!state.order.isUpdated &&
			!state.order.isFailed) ||
		state.order.isLoading
	) {
		return "Loading...";
	}

	return (
		<div className={classes.root}>
			<div align="right">
				{["right"].map((anchor) => (
					<React.Fragment key={anchor}>
						<span
							className="fa-stack fa-2x has-badge"
							data-count={state.order.order.items.reduce(
								(x, y) => x + y.quantity,
								0
							)}
							onClick={toggleDrawer(anchor, true)}
						>
							<i className="fa fa-circle fa-stack-2x fa-inverse"></i>
							<i className="fa fa-shopping-bag fa-stack-2x red-cart"></i>
						</span>

						<Drawer
							anchor={anchor}
							open={stateCart[anchor]}
							onClose={toggleDrawer(anchor, false)}
						>
							{list(anchor)}
						</Drawer>
					</React.Fragment>
				))}
			</div>
			<div align="left">
				<Link to="/Shop/">
					<ArrowBackIcon />
				</Link>
			</div>
			<Stepper activeStep={activeStep}>
				{steps.map((label, index) => {
					const stepProps = {};
					const labelProps = {};
					if (isStepOptional(index)) {
						labelProps.optional = (
							<Typography variant="caption">Optional</Typography>
						);
					}
					if (isStepSkipped(index)) {
						stepProps.completed = false;
					}
					return (
						<Step key={label} {...stepProps}>
							<StepLabel {...labelProps}>{label}</StepLabel>
						</Step>
					);
				})}
			</Stepper>
			<div>
				{activeStep === steps.length ? (
					<React.Fragment>
						<Typography variant="h5" gutterBottom>
							Thank you for your order.
						</Typography>
						<Typography variant="subtitle1">
							Your order number is #{state.order.order._id}. We have emailed
							your order confirmation, and will send you an update when your
							order has shipped.
						</Typography>
						<Review />
					</React.Fragment>
				) : (
					<div>
						<Typography className={classes.instructions}>
							{getStepContent(activeStep, ref, state.order.order)}
						</Typography>
						<div>
							{state.order.order.status !== "completed" &&
							!state.order.order.isFailed ? (
								<Button
									disabled={activeStep === 0}
									onClick={handleBack}
									className={classes.button}
								>
									Back
								</Button>
							) : (
								""
							)}
							{isStepOptional(activeStep) && (
								<Button
									variant="contained"
									color="primary"
									onClick={handleSkip}
									className={classes.button}
								>
									Skip
								</Button>
							)}
							{state.order.order.status !== "completed" ? (
								<>
									{!state.order.order.isFailed && (
										<Button
											variant="contained"
											color="primary"
											onClick={handleNext}
											className={classes.button}
										>
											{activeStep === steps.length - 1 ? "Finish" : "Next"}
										</Button>
									)}
								</>
							) : (
								""
							)}
						</div>
					</div>
				)}
			</div>
			<Divider />
			<div> use below code to access the order</div>
			<QRCode
				value={IP.reactServer + "Shop/Order/" + state.order.order._id}
				style={{ paddingTop: 5 }}
			/>
		</div>
	);
};

export default withRouter(OrderScreen);
